        const menuHamburger = document.querySelector(".menu-toggle")
        const navLinks = document.querySelector(".nav-links")
 
        menuHamburger.addEventListener('click',()=>{
        const isOpen = navLinks.classList.toggle('mobile-menu');

        if (isOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }


        //menu du Drpdown en mobile

       const menuItems = document.querySelectorAll('.menu-item-has-children > a');

        if (!menuItems || menuItems.length === 0) {
            return; 
        }
        
         menuItems.forEach(item => {
        item.addEventListener('click', function (e) {

      
      if (window.innerWidth <= 768) {
        e.preventDefault(); // Empêche le lien de rediriger

        const submenu = this.nextElementSibling;

        if (submenu && submenu.classList.contains('sub-menu')) {
          submenu.classList.toggle('show'); // Affiche ou cache le sous-menu
        }
      }
    });
  });
});
        